export const isWhatPercentOf = (balance = 0, cost = 0) => {
  if (balance) {
    return (cost / (balance / 100));
  }

  return 0;
};
